import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["loading"];

var _templateObject, _templateObject2;

import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import withSize from './withSize';
var animation = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% { transform: rotateZ(45deg); }\n  100% { transform: rotateZ(1125deg); }\n"])));
var SpinAnimation = styled.g(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  transform-origin: 12px;\n  animation: ", " 1.125s cubic-bezier(0.5, 0.1, 0.5, 0.9) infinite;\n"])), animation);

var LoadingIndicator = function LoadingIndicator(_ref) {
  var color = _ref.color,
      width = _ref.width,
      height = _ref.height,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    version: "1.1",
    className: className,
    "data-testid": "loading-indicator-icon"
  }, /*#__PURE__*/React.createElement(SpinAnimation, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,19.5 C7.85786438,19.5 4.5,16.1421356 4.5,12 C4.5,7.85786438 7.85786438,4.5 12,4.5 C16.1421356,4.5 19.5,7.85786438 19.5,12 C19.5,16.1421356 16.1421356,19.5 12,19.5 Z M12,18.5 C15.5898509,18.5 18.5,15.5898509 18.5,12 C18.5,8.41014913 15.5898509,5.5 12,5.5 C8.41014913,5.5 5.5,8.41014913 5.5,12 C5.5,15.5898509 8.41014913,18.5 12,18.5 Z",
    fill: color,
    opacity: "0.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4 L12,6 C8.6862915,6 6,8.6862915 6,12 L4,12 C4,7.581722 7.581722,4 12,4 Z",
    fill: color
  })));
};

LoadingIndicator.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
};
LoadingIndicator.defaultProps = {
  color: 'inherit',
  className: ''
};
var SizedLoadingIndicator = withSize(LoadingIndicator);

var withLoadingIndicator = function withLoadingIndicator(Icon) {
  var AnimatedIcon = function AnimatedIcon(_ref2) {
    var loading = _ref2.loading,
        props = _objectWithoutProperties(_ref2, _excluded);

    if (loading) {
      return /*#__PURE__*/React.createElement(SizedLoadingIndicator, props);
    }

    return /*#__PURE__*/React.createElement(Icon, props);
  };

  AnimatedIcon.propTypes = {
    loading: PropTypes.bool
  };
  AnimatedIcon.defaultProps = {
    loading: false
  };
  return AnimatedIcon;
};

export default withLoadingIndicator;